import { Controller } from "@hotwired/stimulus"

import $ from "jquery"

export default class extends Controller {
  static targets = [
    "movementType",
    "ptiStatus",
    "sendEdi",
    "truck",
    "stuffedContainer",
    "stuffedContainerSeal",
    "truckDriver",
    "destinationAddress"
  ]

  connect() {
    this.fieldsToDisplay = {
      reefer_pre_trip: ['ptiStatus'],
      stripping_only: ['sendEdi', 'truck'],
      partial_stripping_only: ['sendEdi', 'truck'],
      full_stripping_and_stuffing: ['sendEdi', 'stuffedContainer', 'stuffedContainerSeal'],
      partial_stripping_and_stuffing: ['sendEdi', 'stuffedContainer', 'stuffedContainerSeal'],
      container_weight: ['sendEdi'],
      transfer_in: ['sendEdi'],
      transfer_out: ['sendEdi'],
      unloading: ['sendEdi'],
      loading: ['sendEdi'],
      rail_discharge: ['sendEdi'],
      rail_load: ['sendEdi'],
      gate_in: ['truck', 'sendEdi', 'truckDriver'],
      gate_out: ['truck', 'sendEdi', 'truckDriver', 'destinationAddress']
    }
  }

  detectMovementType() {
    const selectedVal = this.movementTypeTarget.value
    const fields = this.fieldsToDisplay[selectedVal] || []

    // Show and hide based on fieldsToDisplay mapping

    // Get all targets excluding 'movementType'
    const targets = this.constructor.targets.filter(target => target !== "movementType")
    targets.forEach((targetName) => {
      const el = this[`${targetName}Target`]
      if (el) {
        // Toggle visibility using the `hidden` class
        if (fields.includes(targetName)) {
          el.classList.remove("hidden")
        } else {
          el.classList.add("hidden")
        }
      }
    })
  }

  submit(event) {
    let validated = true


    const validateField = ($field) => {
      // Get the original label and required error message from data attributes
      const labelText = $field.data("label") || ""
      const requiredText = $field.data("required") || `${labelText} is required!`

       // Check if field has a value or a data-value (for select2)
      const hasDataValue = $field.data("value") !== "" && $field.data("value") !== undefined
      const isValid = $field.length === 0 || hasDataValue || $field.val()

      // Find the associated label by matching its "for" attribute to field ID
      const label = $(`label[for='${$field.attr("id")}']`)

      // Determine which element should receive the error styling
      const ariaLabelledBy = $field.attr("aria-labelledby")
      const errorTarget = ariaLabelledBy ? $(`span[aria-labelledby='${ariaLabelledBy}']`) : $field

      if (!isValid) {
        // If invalid, update label and add error classes
        validated = false
        label.text(requiredText).addClass("label-error")
        errorTarget.addClass("has-error")
      } else {
        // If valid, reset label and remove error classes
        label.text(labelText).removeClass("label-error")
        errorTarget.removeClass("has-error")
      }
    }

    // Loop through all inputs/selects that require validation
    // Each should have the class "validate-field" and relevant data attributes for messaging
    $(".validate-field").each(function () {
      validateField($(this))
    })


    const movementType = $("#movement_movement_type").val()

    if (
      ["gate_out", "gate_in"].includes(movementType) &&
      !$("#movement_gate_id").val()
    ) {
      validated = false
      const gateLabel = $("label[for='movement_gate_id']")
      gateLabel.text($("#movement_gate_id").data("required")).addClass("label-error")
      $("span[aria-labelledby='select2-movement_gate_id-container']").addClass("has-error")
    } else {
      $("label[for='movement_gate_id']").text($("#movement_gate_id").data("label")).removeClass("label-error")
      $("span[aria-labelledby='select2-movement_gate_id-container']").removeClass("has-error")
    }

    if (movementType === "reefer_pre_trip") {
      const group = document.querySelector('[data-admin-movement-form-target="ptiStatus"]');

      if (document.querySelector('input[name="movement[pti_status]"]:checked') === null) {
        validated = false
        $("label[for='movement_pti_status']").text(group.dataset.required).addClass("label-error")
        $("#pti_status").addClass("has-error")
      } else {
        $("label[for='movement_pti_status']").text(group.dataset.label).removeClass("label-error")
        $("#pti_status").removeClass("has-error")
      }
    }

    if (!validated) {
      event.preventDefault()
      event.stopImmediatePropagation();
      window.scrollTo(0, 0)
    }
  }
}
